module.exports = __webpack_public_path__ + "img/preschool-english-sertif-2-small.d894b1ae.jpg";